import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-models',
  templateUrl: './vehicle-models.component.html',
  styleUrls: ['./vehicle-models.component.scss']
})
export class VehicleModelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
